import { Module } from 'vuex-smart-module';
import EditableCoursesRequestActions from './actions';
import EditableCoursesRequestGetters from './getters';
import EditableCoursesRequestMutations from './mutations';
import EditableCoursesRequestState from './state';

export default new Module({
  state: EditableCoursesRequestState,
  mutations: EditableCoursesRequestMutations,
  actions: EditableCoursesRequestActions,
  getters: EditableCoursesRequestGetters,
});
